<template>
	<div class="login flex align-center justify-center">
		<div style="color: #FFFFFF;width:37%;text-align: left !important;">
			<div class="font">我们的便携可靠方法</div>
			<div style="font-size: 38px;margin-top: 15px;">查学校，查专业，查双选会就用HR校招助手!</div>
			<div style="font-size: 14px;margin: 25px 0;">
			 <div>全国3012所高校，2500所中专任意查。</div>
				<div style="margin:5px 0;">双选会信息及时掌握！就业办老师直接对接！校园宣讲会及时申请！</div>
				<div>合适的生源及早联络！成为您的好助手是我们永恒的追求！！</div>
			</div>
			<div class="flex align-center">
				<img src="../../assets/img/Play11.png" style="width: 100px;" />
				<div style="margin-left: 15px;">
					<div class="font">找学校</div>
				 <div style="margin-top:5px ;">是什么使我们与众不同</div>
				</div>
			</div>
		</div>
		<div style="width:10%;"></div>
		<div class="content flex direction-column justify-align-center"
			style="width:25%;height:80vh;border-radius: 20px;background: #FFFFFF;">
			<div style="font-size: 22px;margin-bottom: 15px;">欢迎注册</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
			 <div style="width:50px;text-align: left;">手机号</div>
				<input type="text" v-model="tel" placeholder="请输入手机号(必填)" />
			</div>
			<div class="flex align-center font"
				style="position: relative; border-bottom:1px solid #EBEEF5;padding:5px 0 ">
				<div style="width:50px;text-align: left;">密码</div>
				<input :type="state" v-model="psw" placeholder="请输入登录密码(必填)" @blur="psw_blur" style="width:170px" />
				<img v-if="state=='password'" class="xiaoshou" src="../../assets/img/dl2.png" style="width:15px" @click="state='text'" />
				<img v-if="state=='text'" class="xiaoshou" src="../../assets/img/dl1.png" style="width:15px" @click="state='password'" />
				<span style="color: red;position: absolute;right:-140px" v-if="pass==1">密码必须大于6位</span>
			</div>
			<div class="flex align-center font"
				style="position: relative; border-bottom:1px solid #EBEEF5;padding:5px 0">
				<div style="width:50px;text-align: left;">邮箱</div>
				<input type="text" v-model="email" @blur="email_blur" placeholder="请输入邮箱(必填)" />
				<span style="color: red;position: absolute;right:-120px">{{message}}</span>
			</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
				<div style="width:50px;text-align: left;">公司名称</div>
				<input type="text" v-model="title" placeholder="请输入公司名称(必填)" />
			</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
				<div style="width:50px;text-align: left;">姓名</div>
				<input type="text" v-model="name" placeholder="请输入姓名(选填)" />
			</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
				<div style="width:50px;text-align: left;">职位</div>
				<input type="text" v-model="position" placeholder="请输入职位(选填)" />
			</div>
			<div class="font" style="margin-top: 10px;color:red;" v-if="bitian==1">请确认必填项是否输入完成</div>
			<div style="margin-top: 20px; width:240px;color:#FFFFFF;border-radius: 5px;padding:9px 0;text-align: center;"
				class="font backbg xiaoshou" @click=" nextStep">注册</div>
			<div class="font" style="margin-top: 20px;color:#AAAAAA;">已有账号？<span class="color xiaoshou"
					@click="login()">立即登录</span></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tel: '',
				psw: '',
				email: '',
				title: '',
				name: '',
				position: '',
				state: 'password', //密码状态
				// 弹窗
				popup: 0,
				// 邮箱格式
				message: '',
				// 是否必填
				bitian: 0,
				// 密码
				pass: 0,
			}
		},
		mounted() {

		},
		methods: {
			login() {
				this.$router.push('/login');
			},
			psw_blur() {
				if (this.psw.length >= 6) {
					this.pass = 0
				} else {
					this.pass = 1

				}
			},
		 email_blur() {
				var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
				if (!verify.test(this.email)) {
					this.message = '邮箱格式错误'
				} else {
					this.message = ''

				}
			},
			nextStep() {
				if (this.tel != '' && this.psw != '' && this.email != '' && this.title != '') {
					this.bitian = 0;
					this.zuce();
				} else {
					this.bitian = 1;
				}
			},
			zuce() {
				let self = this;
				this.$axios
					.post('/api/register', {
							mobile: this.tel,
							password: this.psw,
							email: this.email,
							company_name: this.title,
							name: this.name,
							position_name: this.position
					})
					.then((res) => {
						// console.log(res,"注册");
						if (res.data.code == 200) {
									this.$message({
					          message: '注册成功',
										type: 'success',
										duration: 1500,
										onClose(){
											self.$router.replace('/login')
										}
					        });
						}else{
							this.$message.error(res.data.msg)
						}
					});
			}
		}
	}
</script>

<style>
	.login {
		width: 100%;
		height: 100vh;
		background-image: url(../../assets/img/de3.png);
		background-size: 100% 100%;
	}

	input {
		outline: none;
		border: none;
		padding: 10px;
		width: 190px;
	}

	input::placeholder {
		color: #AAAAAA;
		font-size: 12px;
	}
</style>
